<template>
  <div class="Listings_SortBy items-start flex">
    <div class="dropdown" :class="$style.dropdown">
      <button data-toggle="dropdown" class="space-x-3 text-blackest rounded-full bg-grey-lighter focus:outline-hidden">
        <FaIcon :icon="['fal', 'sort']" />
        <span class="font-bold">{{ sortBy }}</span>
      </button>
      <ul class="dropdown-menu">
        <li v-for="(label, value) in sortLabels" @click="setSort(value)" :key="value">
          {{ label }}
        </li>
      </ul>
    </div>

    <div class="dropdown ml-4" :class="$style.dropdown">
      <button data-toggle="dropdown" class="space-x-3 text-blackest rounded-full bg-grey-lighter focus:outline-hidden">
        <span class="font-bold">{{ per }} per page</span>
        <span class="caret" />
      </button>
      <ul class="dropdown-menu">
        <li v-for="value in perOptions" @click="setPerPage(value)" :key="value">
          {{ value }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import omit from "lodash/omit"
import ListingFilters from "@/lib/ListingFilters"

const perOptions = [20, 40, 60, 80, 100]

export default {
  name: "Listings.SortBy",
  data() {
    return {
      perOptions,
    }
  },
  methods: {
    setSort(sort) {
      this.mergeFilter({ sort })
    },
    ...mapActions("filter", ["setPerPage", "mergeFilter"]),
  },
  computed: {
    sortLabels() {
      return omit(ListingFilters.sortLabelMap(), ["new", "display_order"])
    },
    firstResult() {
      return (this.page - 1) * this.per + 1
    },
    lastResult() {
      return (this.page - 1) * this.per + this.per
    },
    sortBy() {
      return this.sortLabels[this.sort]
    },
    ...mapState("filter", {
      page: ({ filters }) => filters.page,
      per: ({ filters }) => filters.per,
      sort: ({ filters }) => filters.sort,
    }),
  },
}
</script>

<style module>
@import "@/css/tailwind_theme.css";
@reference "tailwindcss";

.select {
  @apply border border-grey bg-transparent py-4 pl-2 ml-2;
}

.dropdown button {
  @apply py-4 px-4;
}

.dropdown ul {
  @apply py-0;
}

.dropdown li {
  @apply py-1 px-4;
  cursor: pointer;
}

.dropdown li:hover {
  @apply bg-primary text-white;
}
</style>
